import { Injectable } from '@angular/core';
import { SurveyService } from './survey.service';
import { VariablesService } from './variables.service';
import { QuestionsService } from './questions.service';
import { FormJsonService } from './form-json.service';
import { CUSTOM_WIDGET_TYPES } from '../../../portal/form-processor/widgets/widgets-names';
import { Question } from 'survey-core/typings/packages/survey-core/src/question';
import { PaymentsUtilsService } from '../../utils/payments-utils.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyPayloadService {
  constructor(private surveyService: SurveyService,
              private variablesService: VariablesService,
              private questionsService: QuestionsService,
              private formJsonService: FormJsonService,
              private paymentsUtilsService: PaymentsUtilsService) {
  }

  getSurveyPayload() {
    const questions = this.surveyService.surveyModel.getAllQuestions();
    let formData = this.surveyService.surveyModel.data;

    delete formData['sign'];
    let headerData: any = {};
    let label = '';
    for (const question of questions) {
      label = question.valueName || question.name;
      if (this.questionsService.getQuestion(question.name).getType() !== 'html') {
        if (!question['includeInOutput']) {
          delete formData[label];
        }
        if (question['identifyingQuestion']) {
          headerData[label] = question.value;
        }
      }
      this.removeCustomQuestionType(formData, question, label);
    }
    formData.headerData = headerData;

    console.log('chargesSummary', this.variablesService.chargesSummary);
    if (this.formNeedsPayment()) {
      this.processPaymentProperties(formData);
    }
    console.log(formData);

    const request = {
      'person_id': this.getPersonId(this.formJsonService.tgForm),
      'form_id': this.formJsonService.tgForm.form_id,
      'response_header_id': this.formJsonService.tgForm.response_header_id,
      'submitted': true,
      'response_json': JSON.stringify(formData)
    };

    return request;
  }

  private removeCustomQuestionType(formData: any, question: Question, label: string) {
    if (CUSTOM_WIDGET_TYPES.includes(question.getType())) {
      delete formData[label];
    }
  }

  private getPersonId(tgForm: any) {
    return tgForm.person_id && tgForm.person_id !== 'undefined' ? parseInt(tgForm.person_id) : null;
  }

  private formNeedsPayment() {
    const totalCharge = this.variablesService.getVariable('totalcharge');

    return totalCharge > 0;
  }

  private processPaymentProperties(formData: any) {
    if (this.paidByTelecheck()) {
      this.removeCreditCardProperties(formData);
    } else {
      this.removeTelecheckProperties(formData);
      formData.ccnumber = this.paymentsUtilsService.getMaskedCreditCardNumber(formData.ccnumber);
    }
    formData.totalCharge = this.variablesService.totalChargesFormatted;
    formData.chargeSummary = this.variablesService.chargesSummary;
  }

  private paidByTelecheck() {
    return this.surveyService.surveyModel.getQuestionByName('PaymentMethod')?.value === 'TeleCheck';
  }

  private removeCreditCardProperties(formData: any) {
    delete formData['ccaddress1'];
    delete formData['cccity'];
    delete formData['ccstate'];
    delete formData['cczip'];
  }

  private removeTelecheckProperties(formData: any) {
    delete formData['AccountName'];
    delete formData['ecaddress1'];
    delete formData['eccity'];
    delete formData['ecstate'];
    delete formData['eczip'];
    delete formData['DriversLicenseState'];
    delete formData['DateOfBirth'];
    delete formData['MICRNumber'];
    delete formData['CheckNumber'];
  }
}
